import React from 'react';
import { getAvatarColor, getInitials } from '../../utils/avatarUtils';

const SIZE_CLASSES = {
  xs: 'w-8 h-8 text-xs',
  sm: 'w-9 h-9 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-11 h-11 text-sm',
  xl: 'w-12 h-12 text-base',
  '2xl': 'h-24 w-24 text-2xl',
};

export const Avatar = ({ user, size = 'md', className = '' }) => {
  const avatarColor = getAvatarColor(user);
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  return (
    <div
      className={`flex-shrink-0 rounded-full ${avatarColor.className} text-white flex items-center justify-center font-medium relative overflow-hidden ${sizeClass} ${className}`}
      style={avatarColor.style}
    >
      <span>{getInitials(user)}</span>
      {user?.profile_picture_url && (
        <img
          src={user.profile_picture_url}
          alt=""
          className="absolute inset-0 w-full h-full rounded-full object-cover"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      )}
    </div>
  );
};
